import styles from './index.module.css';

export interface NavSection {
  id: string;
  label: string;
}

interface Props {
  sections: NavSection[];
}

/**
 * Anchor links to the page's sections. Renders nothing for a single section:
 * a one-item nav only asserts there is more to find.
 */
const SectionNav = ({ sections }: Props) => {
  if (sections.length < 2) return null;
  return (
    <nav aria-label="Account sections" className={styles.nav}>
      <ul className={styles.list}>
        {sections.map((section) => (
          <li key={section.id}>
            <a href={`#${section.id}`} className={styles.link}>
              {section.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default SectionNav;
